import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var LayerApi = /** @class */ (function () {
    function LayerApi(api) {
        this.api = api;
        this.layerProperties = "\n        name,\n        id,\n        categoryId,\n        filter,\n        description,\n        isGroupLayer,\n        queryJSON,\n        labelingInfoJSON,\n        sources,\n        url,\n        renderersJSON,\n        parentId,\n        typeId,\n        graphicsJSON,\n        routingDetailJSON\n    ";
    }
    Object.defineProperty(LayerApi.prototype, "Api", {
        get: function () { return this.api; },
        enumerable: true,
        configurable: true
    });
    LayerApi.prototype.getLayerRecordCount = function (layerId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query ($query: QueryInput!) {\n                    layers(id: " + layerId + "){\n                        recordCount(query: $query)\n                        maximumRecordUpdateDate\n                    }\n                }\n        ", { query: query || {} }, 'GET', 'layers')];
                    case 1: 
                    // TODO setup interfaces for layers, features etc
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Retrieves distinct values for a layer / layer column.
     */
    LayerApi.prototype.getDistinctValues = function (layerId, name, query, first) {
        if (first === void 0) { first = 5000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layers, columns;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layers = null;
                        name = name.toUpperCase();
                        if (!query) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n                    query ($query: QueryInput!) {\n                        layers(id:" + layerId + ") {\n                            columns(name:\"" + name + "\") \n                                {name distinctValues(query: $query, first:" + first + ")}}}\n            ", { layerId: layerId, name: name, query: query }, 'GET', 'layers')];
                    case 1:
                        layers = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                    query {\n                        layers(id:" + layerId + ") {\n                            columns(name:\"" + name + "\") \n                                {name distinctValues(first:" + first + ")}}}\n            ", { layerId: layerId, name: name, query: query }, 'GET', 'layers')];
                    case 3:
                        layers = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (layers.length > 0) {
                            columns = layers[0].columns;
                            if (columns.length > 0) {
                                return [2 /*return*/, columns[0].distinctValues.sort()];
                            }
                        }
                        return [2 /*return*/, []];
                }
            });
        });
    };
    /**
     *  Retrieves distinct values for a table column.
     */
    LayerApi.prototype.getColumnDistinctValues = function (tableName, tableOwner, columnName, query, first) {
        if (first === void 0) { first = 5000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tables, distinct, columns;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query ($query: QueryInput, $tableName: [String], $tableOwner: [String], $columnName: [String], $first: Int) {\n                tables(name: $tableName, owner: $tableOwner) {\n                    columns(name: $columnName) {\n                        distinctValues(first: $first, query: $query)\n                    }\n                }\n            }\n            ", { tableName: tableName, tableOwner: tableOwner, columnName: columnName, first: first, query: query }, 'GET', 'tables')];
                    case 1:
                        tables = _a.sent();
                        distinct = [];
                        if (tables.length > 0) {
                            columns = tables[0].columns;
                            if (columns.length > 0) {
                                distinct = columns[0].distinctValues.sort();
                            }
                        }
                        return [2 /*return*/, distinct];
                }
            });
        });
    };
    /**
     *  Retrieve map layers.
     *  @param id ID of layer to be retrieved. Optional - leave blank [] to get all.
     *  @param query Specify layer properties if you want to return data other than default. Optional
     */
    LayerApi.prototype.getLayers = function (id, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = props ? props : this.layerProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query GetLayers($id: [Int]) {\n                    layers(id: $id){\n                        " + props + "\n                    }\n                }\n        ", { id: id }, 'GET', 'layers')];
                    case 1: 
                    // TODO setup interfaces for layers, features etc
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Retrieves layer data for the grid.
     */
    LayerApi.prototype.getLayerInfo = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLayers([layerId], 'id name queryJSON columns(orderBy:["alias","name"]){alias, name, databaseDataType, databaseDataLength, databaseColumnOrder, columnIdentifierId}')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getData = function (layerId, fieldNames, query, first) {
        if (first === void 0) { first = 1000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layers, fieldNamesJoined, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layers = null;
                        fieldNamesJoined = fieldNames.map(function (x) { return "\"" + x + "\""; }).join(',');
                        if (!query) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n                    query ($query: QueryInput!) {\n                        layers(id:" + layerId + ") {\n                            data(query: $query, fieldNames:[" + fieldNamesJoined + "], first:" + first + ")                        \n                        }}\n            ", { layerId: layerId, query: query }, 'GET', 'layers')];
                    case 1:
                        layers = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                    query {\n                        layers(id:" + layerId + ") {\n                            data(fieldNames:[" + fieldNamesJoined + "], first:" + first + ")                        \n                        }}\n            ", { layerId: layerId }, 'GET', 'layers')];
                    case 3:
                        layers = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (layers.length > 0) {
                            data = layers[0].data;
                            if (data.length > 0) {
                                return [2 /*return*/, data];
                            }
                        }
                        return [2 /*return*/, []];
                }
            });
        });
    };
    LayerApi.prototype.getClassBreakData = function (layerId, fieldNames, classes, forceUniqueValues, query, columnIsDate, classBreakLabels) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNamesJoined;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fieldNamesJoined = fieldNames.map(function (x) { return "\"" + x + "\""; }).join(',');
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query ($query: QueryInput!) {\n                    layers(id:" + layerId + ") {\n                        classBreakData(" + (query ? 'query: $query, ' : '') + "fieldNames:[" + fieldNamesJoined + "], classes: " + classes + ", forceUnique: " + forceUniqueValues + ", columnIsDate: " + columnIsDate + ", useNewLabels: true, classBreakLabels: " + classBreakLabels + ")\n                    }}\n        ", { layerId: layerId, query: query }, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Text based layer search
     * @param layerSearchText Input string to search layer catalog
     */
    LayerApi.prototype.getLayerSearch = function (layerSearchText) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query GetLayers($layerSearchText: [String]) {\n                    layers(search: $layerSearchText){\n                        " + this.layerProperties + "\n                    }\n                }\n        ", { layerSearchText: layerSearchText }, 'GET', 'layers')];
                    case 1: 
                    // TODO setup interfaces for layers, features etc
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Retrieves distinct values for a table / table column.
     */
    LayerApi.prototype.getDistinctTableValues = function (tableId, name, first) {
        if (first === void 0) { first = 5000; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var table, columns;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = name.toUpperCase();
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query {\n                    tables(id:" + tableId + ") {\n                        columns(name:\"" + name + "\") \n                            {owner name distinctValues(first:" + first + ")}}}\n        ", { tableId: tableId, name: name }, 'GET', 'tables')];
                    case 1:
                        table = _a.sent();
                        columns = table[0].columns;
                        if (columns.length > 0) {
                            return [2 /*return*/, columns[0].distinctValues.sort()];
                        }
                        return [2 /*return*/, []];
                }
            });
        });
    };
    LayerApi.prototype.getLayerChildTables = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetLayerChildTables($layerId: [Int]) {\n              layerChildTables(layerId: $layerId) {\n                  layerId\n                  tableId\n                  parentPrimaryKeyColumnName\n                  childParentKeyColumnName\n                  layerChildRelationshipName\n                  orderKeyColumnName\n                  columnList\n              }\n          }\n        ", { layerId: layerId }, 'GET', 'layerChildTables')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getAllLayerChildTables = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetLayerChildTables {\n              layerChildTables{\n                  layerId\n                  tableId\n                  parentPrimaryKeyColumnName\n                  childParentKeyColumnName\n                  layerChildRelationshipName\n                  orderKeyColumnName\n              }\n          }\n        ", {}, 'GET', 'layerChildTables')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getLayerChildTable = function (layerId, tableId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetLayerChildTable($layerId: [Int], $tableId: [Int]) {\n              layers(id: $layerId) {\n                  childTables(id: $tableId) {\n                      " + props + "\n                  }\n              }\n          }\n        ", { layerId: layerId, tableId: tableId }, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getLayerChildTableWithData = function (layerId, tableId, names, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNames;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fieldNames = names.join(',');
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetLayerChildTable($layerId: [Int], $tableId: [Int], $fieldNames: [String]!, $query:QueryInput) {\n              layers(id: $layerId) {\n                  childTables(id: $tableId) {\n                     id\n                     data(\n                     fieldNames: $fieldNames,\n                     query: $query)\n                  }\n              }\n          }\n        ", { layerId: layerId, tableId: tableId, fieldNames: fieldNames, query: query }, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getTableRMSKeysByName = function (tableName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetTableRMSByName($tableName: [String]) {\n              getTableRMSByName(tableName: $tableName) {\n                id\n                tableId\n                layerDisplayName\n                tableDisplayName\n                tableName\n                geometryType\n                ctyCodeColName\n                strtnoColName\n                jurisColName\n                segBgnColName\n                offsetBgnColName\n                segEndColName\n                offsetEndColName\n                sideIndColName\n              }\n            }", { tableName: tableName }, 'GET', 'getTableRMSByName')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getTableRMSKeys = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetLayerTableRoadway {\n              layerTableRoadway {\n                id\n                tableId\n                layerDisplayName\n                tableDisplayName\n                tableName\n                geometryType\n                ctyCodeColName\n                strtnoColName\n                jurisColName\n                segBgnColName\n                offsetBgnColName\n                segEndColName\n                offsetEndColName\n                sideIndColName\n              }\n            }", {}, 'GET', 'layerTableRoadway')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getTable = function (tableId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetTable($tableId: [Int]) {\n              tables(id: $tableId) {\n                  " + props + "\n              }\n          }\n        ", { tableId: tableId }, 'GET', 'tables')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Retrieve layer/table information for the nearby feature for this application
     *  @param appId Application ID to return nearbyAssets for.
     */
    LayerApi.prototype.getApplicationNearbyAssets = function (appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query {\n                applications(id: " + appId + ") {\n                    nearbyAssets {\n                        id,\n                        parentId,\n                        relationshipName,\n                        layerId,\n                        tableId,\n                        parentJoinKey,\n                        joinKey,\n                        columnList\n                        templates {\n                            id\n                            sourceId\n                            sourceType\n                            type\n                            functionType\n                            format\n                            layout\n                        }\n                    }\n                }\n            }\n        ", {}, 'GET', 'applications')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Retrieve children of the passed in layerTableChildId from the layerTable hierarchy
     *  @param parentId ID(s) of parent record in heirarchy to return children for.
     */
    LayerApi.prototype.getLayerTableChildren = function (parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query ($parentId: [Int]) {\n                    layerTableChildren(parentId: $parentId){\n                        id\n                        parentId\n                        relationshipName\n                        layerId\n                        tableId\n                        parentJoinKey\n                        joinKey\n                        columnList\n                    }\n                }\n        ", { parentId: parentId }, 'GET', 'layerTableChildren')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.shareLayer = function (userIds, layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation ShareLayer($userIds: [Int], $layerId: Int) {\n                    shareLayer(userIds: $userIds, layerId: $layerId)\n                }\n        ", { userIds: userIds, layerId: layerId }, 'GET', 'shareLayer')];
                    case 1: 
                    // TODO setup interfaces for layers, features etc
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.unshareLayer = function (userId, layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation UnshareLayer($userId: [Int], $layerId: Int) {\n                    unshareLayer(userIds: $userId, layerId: $layerId)\n                }\n        ", { userId: userId, layerId: layerId }, 'GET', 'unshareLayer')];
                    case 1: 
                    // TODO setup interfaces for layers, features etc
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.saveLayer = function (layer, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var properties, propertiesCommaDelimited;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        properties = Object.keys(layer);
                        if (properties.indexOf('id') < 0) {
                            properties.push('id');
                        }
                        propertiesCommaDelimited = properties.join(',');
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation saveLayer($layer: LayerInput!, $userId: Int){\n                saveLayer(layer: $layer, userId: $userId){\n                    " + propertiesCommaDelimited + "\n                }\n            }\n        ", { layer: this.sanitize(layer), userId: userId }, 'POST', 'saveLayer.id')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.createClippedRMSGeom = function (clipRanges) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, ranges, request, ranges_1, ranges_1_1, r;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ranges = Array.isArray(clipRanges) ? clipRanges : [clipRanges];
                        request = 'mutation createMultipleClippedRMSGeom { createMultipleClippedRMSGeom( rmsobject: [';
                        try {
                            for (ranges_1 = tslib_1.__values(ranges), ranges_1_1 = ranges_1.next(); !ranges_1_1.done; ranges_1_1 = ranges_1.next()) {
                                r = ranges_1_1.value;
                                request += "{county: \"" + r.county + "\", route: \"" + r.route + "\", seg1: \"" + r.seg1 + "\", offset1: \"" + r.offset1 + "\", seg2: \"" + r.seg2 + "\", offset2: \"" + r.offset2 + "\", side: \"" + r.side + "\"}";
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (ranges_1_1 && !ranges_1_1.done && (_a = ranges_1.return)) _a.call(ranges_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        request += '])}';
                        return [4 /*yield*/, this.api.http2.graphqlRequest(request, null, 'POST', 'createMultipleClippedRMSGeom')];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    LayerApi.prototype.sanitize = function (layer) {
        //only keep layer properties
        var result = this.api.pick(layer, this.layerProperties.split(',').map(function (p) { return p.trim(); }));
        if (!result.id) {
            delete layer.id;
        }
        return result;
    };
    LayerApi.prototype.delete = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation DeleteLayer($layerId: Int!) {\n                deleteLayer(id: $layerId)\n            }\n        ", { layerId: layerId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getDocSources = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetLayerDocSources($layerId: [Int]) {\n            layers(id: $layerId) {\n              name\n              layerDocSource {\n                id\n                fields\n                type\n                template\n                options\n                url\n              }\n            }\n          }", { layerId: layerId })];
                    case 1:
                        res = _a.sent();
                        if (!res || !res.layers || res.layers.length !== 1 || !res.layers[0].layerDocSource) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, res.layers[0].layerDocSource];
                }
            });
        });
    };
    /**
     * Child Records Filter
     * @param childRecordsFilter Get child tables by layer
     */
    LayerApi.prototype.getLayerChildRelationships = function (parentLayerId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetLayerChildRelationships($parentLayerId:[Int]) {\n              layerChildRelationships(parentLayerId:$parentLayerId){\n                " + props + "\n              }\n            }", { parentLayerId: parentLayerId }, 'GET', 'layerChildRelationships')];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    LayerApi.prototype.getChildRecord = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetLayerChildRelationships($parentLayerId:[Int]) {\n              layerChildRelationships(parentLayerId:$parentLayerId){\n                layerChildRelationshipName\n\t            id\n              }\n            }", { layerId: layerId })];
                    case 1:
                        res = _a.sent();
                        if (!res || !res.layerChildRelationships || res.layerChildRelationships.length !== 1) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, res.layers];
                }
            });
        });
    };
    LayerApi.prototype.getUserLayersFolders = function (id, properties) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query getUserLayersFolders($id: [Int]) {\n                users(id: $id) {\n                    " + properties + "\n                }\n            }", { id: id }, 'GET', 'users')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.saveLayerToUserFolder = function (layerId, folderId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation SaveLayerToUserFolder($layerId: Int, $folderId: Int) {\n                saveLayerToUserFolder(newUserFolderId: $folderId, layerId: $layerId)\n            }\n        ", { layerId: layerId, folderId: folderId }, 'POST', 'saveLayerToUserFolder')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getUserLayers = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUserLayers($layerId: [Int]) {\n                    layers(id: $layerId) {\n                        userLayers{\n                            accessLevel\n                            userId\n                        }\n                    }\n            } ", { layerId: layerId }, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.emailAboutSharedLayer = function (emailAddresses, emailSubject, emailBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation EmailAboutSharedLayer($emailAddresses: [String], $emailSubject: String, $emailBody: String) {\n                emailAboutSharedLayer(emailAddresses: $emailAddresses, emailSubject: $emailSubject, emailBody: $emailBody)\n            }\n        ", { emailAddresses: emailAddresses, emailSubject: emailSubject, emailBody: emailBody }, 'GET', 'emailAboutSharedLayer')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getTableEditableColumns = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetTableEditableColumns($tableId: [Int]) {\n                tableEditableColumns(tableId: $tableId) {\n                    id\n                    name\n                    displayOrder\n                    inputType\n                    isEditable\n                    isInsertable\n                    validationType\n                    tableId\n                }\n            }\n        ", { tableId: tableId }, 'GET', 'tableEditableColumns')];
                    case 1: return [2 /*return*/, (_a.sent()).map(function (tableEditableColumn) { return ({
                            id: tableEditableColumn.id,
                            name: tableEditableColumn.name,
                            displayOrder: tableEditableColumn.displayOrder,
                            tableId: tableEditableColumn.tableId,
                            isEditable: tableEditableColumn.isEditable.toLowerCase() === 't',
                            isInsertable: tableEditableColumn.isInsertable.toLowerCase() === 't',
                            inputType: tableEditableColumn.inputType ? JSON.parse(tableEditableColumn.inputType) : undefined,
                            validationType: tableEditableColumn.validationType ? JSON.parse(tableEditableColumn.validationType) : undefined
                        }); })];
                }
            });
        });
    };
    LayerApi.prototype.getPetlProjectColumnAliases = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.request("petl/projects/" + projectId + "/column-aliases", { method: 'GET' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getBaseParentId = function (parentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          query GetBaseParentId($parentId: Int!) {\n              baseParentId(parentId: $parentId)\n          }\n        ", { parentId: parentId }, 'GET', 'baseParentId')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getLayerPermissions = function (layerIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetLayerPermissions($layerId: [Int]) {\n                layerPermissions(layerId: $layerId) { layerId, name }\n            }\n        ", { layerId: layerIds }, 'GET', 'layerPermissions')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.prototype.getFilterDateFormats = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetFilterDateFormats {\n                filterDateFormats\n            }\n        ", {}, 'GET', 'filterDateFormats')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LayerApi.ngInjectableDef = i0.defineInjectable({ factory: function LayerApi_Factory() { return new LayerApi(i0.inject(i1.Api)); }, token: LayerApi, providedIn: "root" });
    return LayerApi;
}());
export { LayerApi };
